import IAmount from "./IAmount";
import IOrder from "./IOrder";
import IItem from "@/module/main/dto/financing-v1/IItem";

export default class Order implements IOrder {
    constructor(public number: string,
                public totalPrice: IAmount | undefined,
                public items: IItem[]
    ) {
    }
}
